import Macy from 'macy'

export const galleryLayout = () => {
  const els = document.querySelectorAll('.gallery')

  if (!els.length) return

  els.forEach(el => {
    const container = el.querySelector('.gallery__images')
    const allImages = Array.from(el.querySelectorAll('.gallery__entry'))
    const filters = el.querySelectorAll('.gallery__category')
    const masonry = Macy({
      container: container,
      trueOrder: false,
      waitForImages: false,
      margin: 36,
      columns: 3,
      breakAt: {
        1024: {
          columns: 2
        },
        650: {
          columns: 1,
          margin: 24
        }
      }
    })

    setTimeout(() => masonry.recalculate(true), 100)

    filters.forEach(filter => {
      filter.addEventListener('click', () => filterImages(filter.getAttribute('data-slug')))
    })

    const filterImages = (filter) => {
      const images = allImages.filter((image) => image.getAttribute('data-shape') == filter || filter == null)
      container.innerHTML = ''
      container.append(...images)
      masonry.recalculate(true)
    }

  })
} 

export default () => {}